import { resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ag-page_eventinsp position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_card, {
      module: _ctx.module,
      onSearch: _ctx.search,
      onMain: _ctx.mainLink,
      onExport: _ctx.getList,
      onExportend: _ctx.getList
    }, {
      cardNavFilter: _withCtx(() => []),
      _: 1
    }, 8, ["module", "onSearch", "onMain", "onExport", "onExportend"])
  ]))
}